  <template>
  <div class="renewal-search">
    <Header noNav></Header>
    <Loader v-if="isLoading" />
    <b-container>
      <b-row>
        <b-col md="6" sm="12">
          <div class="renewal-search__description">
            <h1 class="renewal-search__description--title">
              Chegou a hora de <br />
              renovar sua proteção!
            </h1>
            <p>Para continuar protegendo o seu aparelho, faça a renovação da sua
              apólice de seguro.
                <b>
                  Atenção: saiba que é necessário que o aparelho seja o mesmo da
                  contratação anterior.
                </b>
            </p>
          </div>
          <div class="renewal-search__form">
            <RenewalInput
              class="renewal-search__input"
              id="policy-number"
              type="tel"
              :errorMessage="isPolicyNumberValid.message"
              :errorCondition="!isPolicyNumberValid.condition"
              label="Número do bilhete"
              v-model="policyNumber"
              placeholder="Somente número"
              :mask="'CICLI.###############'"
            />
            <RenewalInput
              class="renewal-search__input"
              id="cpf"
              type="tel"
              v-model="cpf"
              label="CPF titular do bilhete"
              :errorMessage="isCPFValid.message"
              :errorCondition="!isCPFValid.condition"
              placeholder="829.475.290-81"
              :mask="'###.###.###-##'"
            />
            <b-button
              :disabled="!isValid || isLoading"
              class="renewal-search__btn-send"
              pill
              @click="getPolicyUuid()"
              size="lg">
              Buscar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref="renewal-resume-modal"
      size="lg"
      class="renewal-search__modal"
      centered
      hide-footer
      body-bg-variant="white">
      <br>
      Bilhete não encotrado
    </b-modal>
  </div>
</template>
<script>
import Header from '../Header/Header'
import Loader from '@/components/Loader'
import RenewalInput from './_components/RenewalInput'
import { getPolicy, getAccessToken } from '@/api/services'
import cpfRule from '@/assets/validation/cpf.rule'

export default {
  name: 'RenewalSearch',
  components: {
    Header,
    Loader,
    RenewalInput
  },
  data () {
    return {
      cpf: '',
      policyNumber: '',
      isLoading: false,
      token: ''
    }
  },
  created () {
    getAccessToken()
    .then(({ data }) => {
      this.token = data.access_token
    })
  },
  computed: {
    isCPFValid () {
      let { message, condition } = cpfRule

      if (!this.cpf.length) { message = 'Informe o cpf' }
      return {
        message,
        condition: this.cpf.length === 11 && condition(this.cpf)
      }
    },
    isPolicyNumberValid () {
      return {
        message: 'Informe o número do bilhete',
        condition: this.policyNumber.length
      }
    },
    isValid () {
      return this.isCPFValid.condition && this.isPolicyNumberValid
    }
  },
  methods: {
    getPolicyUuid () {
      const params = { policyNumber: this.policyNumber, cpf: this.cpf, token: this.token }

      this.isLoading = true
      getPolicy(params)
      .then(({ data }) => {
        const { uuid } = data[0]
        const errorMessage = 'Uuid não encontrado'

        if (!uuid) return Promise.reject(errorMessage)
        this.$router.push({
          name: 'Renewal',
          query: { uuid }
        })
      })
      .catch(() => {
        this.$refs['renewal-resume-modal'].show()
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang='scss' scoped>
$breakpoint-nav: 960px;
$breakpoint-tablet: 768px;
$breakpoint-mobile: 480px;
$breakpoint-small-mobile: 320px;

.renewal-search {
  background-color: #f5f7fa;
  min-height: 100%;

  p {
    font-family: Rubik;
    font-size: 18px;
    margin: 0;
  }

  &__description {
    padding-bottom: 48px;
    margin-bottom: 48px;
    border-bottom: 1px solid rgba(190, 194, 198, 0.5);

    p {
      color: #595959;
      @media only screen and (max-width: $breakpoint-mobile) {
        font-size: 16px;
      }
    }

    &--title {
      font: bold 40px Oscine;
      color: #444444;
      margin: 36px 0 28px 0;
      @media only screen and (max-width: $breakpoint-mobile) {
        margin: 0 0 24px 0;
        font-size: 24px;
      }
    }
    :last-child {
      margin-top: 32px;
    }
  }

  &__form {
    width: 50%;
    @media only screen and (max-width: $breakpoint-nav) {
      width: 60%;
    }
    @media only screen and (max-width: $breakpoint-mobile) {
      width: 100%;
    }
  }

  &__input {
    & + & {
      margin-top: 12px;
    }
  }

  &__btn-send {
    margin-top: 16px;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    display: inline-block;
    font: 16px Oscine;
    color: #fff;
    background: #6320e9;
    &:hover{ background: #6320e9;}
    @media only screen and (max-width: $breakpoint-mobile) {
      width: 100%;
    }
  }

  &__modal {
  margin-bottom: 32px;
  border-bottom: 1px solid rgba(190, 194, 198, 0.5);
  }
}
</style>
